import { Box, Stack, Typography, Chip, Button } from "@mui/material";
import { heuresActions } from "../../../../modules/heures/heures.actions.js";

export default function EquipageAlerteRHCard({ alerte, posteOperateurId, dispatch }) {
    const isCritical = alerte.severity === 'critical';
    const isPending = alerte.status === 'pending';
    const isResolved = !isPending;

    const cardSx = isResolved
        ? { background: "#f0fdf4", borderLeft: "4px solid #86efac", border: "1px solid #86efac", borderRadius: "8px", p: "11px 14px" }
        : isCritical
            ? { background: "#fff5f5", borderLeft: "4px solid #ef4444", border: "1px solid #fca5a5", borderRadius: "8px", p: "11px 14px" }
            : { background: "#fffbeb", borderLeft: "4px solid #f59e0b", border: "1px solid #fde68a", borderRadius: "8px", p: "11px 14px" };

    return (
        <Box sx={cardSx}>
            <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap="10px">
                <Box sx={{ flex: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
                        <Chip
                            label={isCritical ? "● Critique" : "⚠ Avertissement"}
                            size="small"
                            sx={{
                                backgroundColor: isCritical ? "#ef4444" : "#f59e0b",
                                color: "white",
                                fontWeight: 700,
                                fontSize: "9px",
                                letterSpacing: "0.05em",
                                textTransform: "uppercase",
                            }}
                        />
                        <Chip
                            label={alerte.status}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: "9px" }}
                        />
                    </Stack>
                    <Typography variant="body2" sx={{ color: "#374151" }}>{alerte.message}</Typography>
                </Box>
                {isPending && (
                    <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                        <Button
                            size="small"
                            variant="outlined"
                            color="success"
                            onClick={() => {
                                dispatch(heuresActions.updateAlerteRH(alerte.id, { status: 'reviewed' }))
                                    .then(() => dispatch(heuresActions.fetchEquipageDetail(posteOperateurId)));
                            }}
                        >
                            VU
                        </Button>
                        <Button
                            size="small"
                            variant="outlined"
                            color="inherit"
                            onClick={() => {
                                dispatch(heuresActions.updateAlerteRH(alerte.id, { status: 'dismissed' }))
                                    .then(() => dispatch(heuresActions.fetchEquipageDetail(posteOperateurId)));
                            }}
                        >
                            IGNORER
                        </Button>
                    </Stack>
                )}
            </Stack>
        </Box>
    );
}
